import { getRegion } from '../helpers/index.js';

const carApiEndpoint = 'getCarApiPayment';

// This goes to Akamai on the Dealer's base domain.
export const defaultEndpoint = `/api/proxy/${carApiEndpoint}`;

// For the few sites that don't go through Akamai, use this alternate endpoint to still get the payments.
// These requests go directly to web-proxy-service instead of through Akamai, but there is still caching.
export const getAlternateEndpoint = (envName='prod') => {
	const region = getRegion(window?.DDC?.userLocation?.userRegion);
	const env = envName === 'prod' ? 'web' : 'web-np';
	return `https://web-proxy-service-${envName}.${region}.${env}.dealer.com/${carApiEndpoint}`;
}

// These are used as inputs in the Accelerate integration.
export const creditRanges = {
	a: [740, 900],
	b: [700, 739],
	c: [670, 699],
	d: [630, 669],
	e: [580, 629]
};

// This function returns creditType based on low and high credit score
export const getCreditType = (creditScoreLow=700, creditScoreHigh=739) => {
	const entry = Object.entries(creditRanges).find(([_key, value]) => value[0] === creditScoreLow && value[1] === creditScoreHigh);
	return entry ? entry[0] : 'b';
};

// These are used to match the scores used by Accelerate when requesting monthly payment values from Car API.
export const creditScores = {
	a: 820,
	b: 720,
	c: 685,
	d: 650,
	e: 605
};

export const priceFields = [
	'internetPrice',
	'msrp',
	'salePrice',
	'askingPrice',
	'retailValue'
];
